/**
 * error.service.ts
 *
 * Created by: Dylan Knight
 * Copyright (c) 2022 Secured Communications. All rights reserved.
 *
**/
"use strict";

import { ErrorInfo, GroupError, HttpError, UnauthError } from "../models/error";

import { http } from "./http.service";

export function reportError(err: Error, title: string): void {
  let errMsg = err.message + (err.stack ? "\n" + err.stack : "");
  if (err instanceof UnauthError) {
    errMsg = `unauth code: ${err.statusCode} msg: ${errMsg}`;
  } else if (err instanceof GroupError) {
    errMsg = `group code: ${err.statusCode} msg: ${errMsg}`;
  } else if (err instanceof HttpError) {
    errMsg = `http code: ${err.statusCode} msg: ${errMsg}`;
  }

  const info: ErrorInfo = {
    message: title,
    error: errMsg,
    level: "error"
  };
  http.post<ErrorInfo, any>("/device/log/", info);
}

export function reportErrorInfo(info: ErrorInfo): void {
  http.post<ErrorInfo, any>("/device/log/", info).catch(err => {
    console.error("Error reporting previous error:", err);
  });
}

